module.exports = __webpack_public_path__ + "img/mpk-gfs-stocking-list-thumb.80e48940.png";